import { AuthGuard } from './guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { content } from './child-routes.module';
import { NotfoundComponent } from './authentication/404/not-found.component';

export const Approutes: Routes = [

	{
		path: '', component: FullComponent, canActivate: [AuthGuard], children: [
			{ path: '', redirectTo: '/dashboard', pathMatch: 'full' },
			{ path: 'dashboard', loadChildren: () => import('./dashboards/dashboard.module').then(m => m.DashboardModule) },
			{ path: 'modulo', loadChildren: () => import('./modulos/modulos.module').then(m => m.ModulosModule) },
		]
	},

	{
		path: '', component: BlankComponent, children: [
			{ path: '', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) }
		]
	},

	{ path: '**', redirectTo: '/404', pathMatch: 'full' },
	{ path: '404', component: NotfoundComponent },
];
